import { Error403Unauthorized } from '@app/components';

import { useCalendarPermissions } from '@pages/Calendar/hooks/useCalendarPermissions';

import { useCalendarContext } from '@pages/Calendar/context';

import { CalendarLayout } from '../../CalendarLayout';

import '../styles/CalendarPage.scss';

import type { FC } from 'react';

export const CalendarPage: FC = () => {
  const { selectedDateMoment, todayMoment } = useCalendarContext();
  const { canAccessJournal, canViewPastRecords } = useCalendarPermissions();

  const isPastDate = selectedDateMoment.isBefore(todayMoment, 'day');
  const isBlocked = !canAccessJournal || (!canViewPastRecords && isPastDate);

  return (
    <div className="CalendarPage" data-testid="calendar-page">
      {isBlocked ? <Error403Unauthorized /> : <CalendarLayout />}
    </div>
  );
};
